export default __webpack_public_path__ + "static/media/circle-minus.a562146f.svg";